const s = (t, e) => {
  const o = t.__vccOpts || t;
  for (const [r, c] of e)
    o[r] = c;
  return o;
};
export {
  s as default
};
